import classNames from "classnames";

type PaginationProps = {
  nextPage: boolean;
  currentPage: number;
  prevPage: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
  loading: boolean;
};

const Pagination = ({
  nextPage,
  currentPage,
  prevPage,
  onNextPage,
  onPrevPage,
  loading,
}: PaginationProps): JSX.Element => {
  return (
    <div className="grid w-full grid-cols-3 px-6 py-2 bg-white shadow-default">
      <button
        disabled={!prevPage || loading}
        onClick={onPrevPage}
        className="col-start-1 col-end-2 justify-self-start"
      >
        <span
          className={classNames("text-lg font-semibold text-primary", {
            "text-grey-dark": !prevPage || loading,
          })}
        >
          Previous
        </span>
      </button>

      <div className="col-start-2 col-end-3 justify-self-center">
        <div className="grid flex-shrink-0 w-10 h-10 px-4 bg-lightest place-content-center">
          <span className="text-base font-semibold text-primary">
            {currentPage}
          </span>
        </div>
      </div>

      <button
        disabled={!nextPage || loading}
        onClick={onNextPage}
        className="col-start-3 col-end-4 justify-self-end"
      >
        <span
          className={classNames("text-lg font-semibold text-primary", {
            "text-grey-dark": !nextPage || loading,
          })}
        >
          Next
        </span>
      </button>
    </div>
  );
};

export default Pagination;
